var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconImport({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 50 55",
    xmlns: "http://www.w3.org/2000/svg",
    fit: "",
    preserveAspectRatio: "xMidYMid meet",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.667 40v-5.333L50 44l-9.333 9.333v-5.466C34 47.867 29.333 50 26 54.667 27.333 48 31.333 41.333 40.667 40zM17.5 10.625V0H1.875A1.87 1.87 0 0 0 0 1.875v36.25A1.87 1.87 0 0 0 1.875 40h26.25A1.87 1.87 0 0 0 30 38.125V12.5H19.375a1.88 1.88 0 0 1-1.875-1.875zm4.695 8.32L17.5 26.25l4.695 7.305A.939.939 0 0 1 21.406 35H18.68a.94.94 0 0 1-.828-.492A398.423 398.423 0 0 1 15 29.14c-.5 1.156-.781 1.562-2.86 5.375a.929.929 0 0 1-.82.492H8.594a.939.939 0 0 1-.79-1.446l4.712-7.304-4.711-7.305a.937.937 0 0 1 .789-1.445h2.719a.94.94 0 0 1 .828.492c2.039 3.813 1.562 2.625 2.859 5.352 0 0 .477-.915 2.86-5.352a.941.941 0 0 1 .828-.492h2.718c.742-.008 1.188.812.79 1.437zM30 9.523V10H20V0h.477c.5 0 .976.195 1.328.547l7.648 7.656c.352.352.547.828.547 1.32z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImport);
export default __webpack_public_path__ + "static/media/icon_import.65e724b53744b5b8319ba7338dc6f50c.svg";
export { ForwardRef as ReactComponent };